<template>
  <div>
    <Loading v-if="isLoading" />
    <div v-else>
      <!-- 和值橫版走勢 -->
      <div style="width: 100%; height: 50vh;">
        <v-chart ref="polar" :options="line" />
      </div>
    </div>
  </div>
</template>

<script>
import { getRuleDetails_web } from '@/api/desktop/trend'

import Loading from '@/components/web/common/Loading'

function getSizeAxisY(lotteryType) {
  switch (lotteryType) {
    case 'k3':
      return 18
    case 'xy28':
      return 27
    default:
      console.warn('getSizeAxisY: lotteryType 對應失敗!', lotteryType)
      return 27
  }
}

export default {
  name: 'HeJhihHengBanZouShihContent', // 和值橫版走勢 content
  components: {
    Loading
  },
  props: {
    lotteryCode: {
      type: String,
      default: ''
    },
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      line: {
        label: { fontSize: 30 },
        color: ['#37A2DA', '#67E0E3', '#9FE6B8', '#F00078', '#BE77FF', '#00DB00', '#FFA042'],
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          show: false,
          left: 20
        },
        xAxis: {
          // offset: 10,
          // position: 'top',
          type: 'category',
          axisTick: {
            interval: () => true
          },
          boundaryGap: true,
          data: [],
          nameLocation: 'middle',
          name: '期号',
          nameTextStyle: {
            fontSize: 16,
            padding: [20, 0, 0, 0]
          }
        },
        yAxis: {
          min: 0,
          max: getSizeAxisY(this.lotteryType),
          interval: 3,
          //   splitNumber: 11,
          type: 'value',
          nameRotate: 0,
          nameLocation: 'middle',
          name: '{x|和\n值\n}',
          data: (new Array(10)).fill().map((nothing, index) => (index + 1)),
          nameTextStyle: {
            rich: {
              x: {
                fontSize: 16,
                padding: 12,
                color: 'black',
                height: 4
              }
            }
          }
        },
        series: [
          {
            name: '和值横版走势',
            type: 'line',
            symbolSize: 6,
            smooth: true,
            data: [],
            animation: false
          }
        ]
      },
      isLoading: true
    }
  },
  watch: {
    lotteryCode: {
      immediate: true,
      handler(lotteryCode) {
        this.getData()
      }
    }
  },
  methods: {
    async getData() {
      this.isLoading = true
      this.line.series[0].data = []

      if (this.lotteryType === 'k3' || this.lotteryType === 'xy28') {
        const [data, error] = await getRuleDetails_web(this.lotteryCode, { count: 30, rules: 'balls' })
        if (error) return

        this.line.xAxis.data = data.map(el => el.period.slice(-3))
        data.forEach(per => {
          const target = per.balls.reduce(function(accumulator, currentValue, currentIndex, array) {
            return accumulator + currentValue
          }, 0)

          this.line.series[0].label = {
            show: true,
            fontSize: 16,
            color: '#141414',
            formatter(data) {
              return data.value
            }
          }

          this.line.series[0].data.push(target)
        })
      }
      this.isLoading = false
    }
  }
}
</script>
